import { apiV1 } from '~/services/api';

export function charge(objectId: string) {
  return apiV1.request({
    url: `/invoices/${objectId}/charge`,
    method: 'PUT',
  });
}

export function get(page?: number, count?: number) {
  return apiV1.request({
    url: '/v1/invoices/',
    method: 'GET',
    params: {
      page,
      results: count,
    },
  });
}

export function getById(invoiceId: string) {
  return apiV1.request({
    url: `/v1/invoices/${invoiceId}`,
    method: 'GET',
  });
}

// Implemented this service in this file instead of invoice-items.service.ts since this hits the /invoices endpoint
export function getInvoiceItemsOfInvoice(invoiceId: string) {
  return apiV1.request({
    url: `/v1/invoices/${invoiceId}/items?results=200`, // Limits the request to get up to 200 invoice items, copied from legacy code
    method: 'GET',
  });
}
